import { useEffect } from 'react'

import { PushProgramTask } from '@apps-common/config/push-notification'
import { useNotifications } from '@apps-common/contexts'
import { INotificationPayload } from '@apps-common/types/portal/push-registration'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

const key = 'program-task-group-notification-listener'

export const useTaskGroupNotificationListener = (tasks: IUnitTaskGroupModel[], callback: (data: INotificationPayload) => void) => {
  const ctx = useNotifications()

  useEffect(() => {
    if (!tasks?.length) {
      return
    }

    const taskIds = new Set(tasks.map((task) => task.id))

    ctx?.subscribeToNotifications({
      id: `${key}`,
      destination: PushProgramTask.destination,
      onNotificationReceived: (event: INotificationPayload) => {
        // console.log('Callback received in program task queue for request:', event)
        // console.log(event.data.taskQueueId, parseInt(event.data.taskQueueId, 10), queueId)
        // if (event.data.taskQueueId && parseInt(event.data.taskQueueId, 10) === queueId) {
        const taskGroupId = parseInt(event?.data?.taskGroupId || '', 10)

        if (!Number.isNaN(taskGroupId) && taskIds.has(taskGroupId)) {
          callback(event)
        }
        // }
      }
    })

    return () => {
      ctx?.unsubscribeToNotifications(`${key}`)
    }
  }, [callback, ctx, tasks])

  return null
}
